import { queryClient } from "@impero-com/common/utils/query_client";
import { useMutation } from "@tanstack/react-query";

import { TestingActivitySubmissionKind } from "api/generated/model";
import { postTestingActivitiesTestingActivityId } from "api/generated/testing-activities/testing-activities";
import { getGetTestingProgramsTestingProgramIdActivitiesQueryKey } from "api/generated/testing-programs/testing-programs";

import { getTestingActivityQueryKey } from "./useTestingActivityQuery";

export interface PatchTestingActivityMutationVars {
    id: string;
    testingProgramId: number;
    submissionKind: TestingActivitySubmissionKind;
}
export function useSubmitTestingActivityMutation() {
    return useMutation({
        mutationFn: (vars: PatchTestingActivityMutationVars) =>
            postTestingActivitiesTestingActivityId(
                vars.id,
                vars.submissionKind,
                { headers: { "Content-Type": "application/json" } }
            ),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({
                queryKey: getTestingActivityQueryKey(vars.id),
            });
            queryClient.invalidateQueries({
                queryKey:
                    getGetTestingProgramsTestingProgramIdActivitiesQueryKey(
                        vars.testingProgramId
                    ),
            });
        },
    });
}
